import React, { useEffect, useState } from 'react'

//Components
import MainCard from '../../components/MainCard/MainCard'
import FichaContainerPGRS from './components/FichaContainerPGRS'

//Context
import { useAuth } from '../../context/auth';

//Helpers
import { showMessage } from '../../helpers/message';

//API
import pgrs_api from '../../api/pgrs_api';
import NovoPGRS from './NovoPGRS';

export default function FichaPGRS({ id, btnVoltar }) {
    const { session, setLoading } = useAuth();

    const [pgrs, setPgrs] = useState(null);
    //estado para edição dos dados do pgrs
    const [editar, setEditar] = useState(false);

    function loadGetItemPGRS(id) {
        setLoading(true);
        pgrs_api.GetItemPGRSGerador(id)
            .then(response => {
                if (response.data) {
                    response.data.tbFormularioPGRS_Id = response.data.tbFormularioPGRS_Id.toString();

                    if (response.data.contratosPendentes.length > 0) {
                        response.data.contratosPendentes = response.data.contratosPendentes
                            .map(contrato => {
                                contrato.checked = true;
                                contrato.contratoPendentePGRS = true;
                                return contrato
                            });
                    }
                }

                setPgrs(response.data)
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }


    function onSubmitAcoesGestor(acao) {
        setLoading(true);
        pgrs_api.InsertAcaoAnaliseGestor(acao)
            .then(response => showMessage("Sucesso", "Ação realizada com sucesso.", "success", btnVoltar))
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadGetItemPGRS(id)
    }, [id]);

    if (editar) {
        return <NovoPGRS
            pgrsItem={pgrs}
            btnVoltar={btnVoltar}
        />
    }

    return (
        <MainCard btnVoltar={btnVoltar} btnEditar={session?.acesso?.sigla == "GS" ? null : () => setEditar(true)}>
            {pgrs && <FichaContainerPGRS
                pgrs={pgrs}
                finalizar={false}
                onSubmitAcoesGestor={onSubmitAcoesGestor}
            />
            }
        </MainCard>
    )
}
